<div id="app-teams-add-dialog">
  <div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-primary">
      <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
        <span class="title dialog-title">
          {{ 'TEAMS-ADD-FORM.TITLE' | translate }}
          @if(isClassTeams) {
            {{ 'TEAMS-ADD-FORM.CLASS' | translate }}
          } @else {
            {{ 'TEAMS-ADD-FORM.STANDARD' | translate }}
          }
        </span>
        <button
          mat-icon-button
          (click)="matDialogRef.close()"
          aria-label="Close dialog">
          <mat-icon>close</mat-icon>
        </button>
      </mat-toolbar-row>
    </mat-toolbar>
    <mat-horizontal-stepper
      class="mat-elevation-z1 mat-stepper-horizontal"
      [linear]="true"
      labelPosition="bottom">
      <mat-step
        [completed]="step1Validation()">
        <form fxLayout="column" fxFill [formGroup]="addTeamsForm">
          <h2 class="step-title">
            {{ 'TEAMS-ADD-FORM.PAGE1.TITLE' | translate }}
          </h2>
          <div fxLayout="column" fxLayoutAlign="start start">
            <h3 class="labels">
              {{ 'TEAMS-ADD-FORM.PAGE1.TEAMTYPE' | translate }}
            </h3>
            <mat-radio-group
                class="radio-teams-type"
                formControlName="teamsType">
              @if(isClassTeams) {
                <div>
                  <mat-radio-button checked="true" [value]="'EDU_Class'" [ngClass]="{'bold-text' : selectedType === 'EDU_Class'}">
                    {{ 'TEAMS-ADD-FORM.PAGE1.CLASS' | translate }}
                  </mat-radio-button>
                    <div class="form-text">
                      {{ 'TEAMS-ADD-FORM.PAGE1.TEAM-CLASS-INFO' | translate }}
                    </div>
                </div>
              }@else{
                <div>
                  <mat-radio-button
                    [value]="'EDU_PLC'"
                    [ngClass]="{'bold-text' : selectedType === 'EDU_PLC'}">
                    {{ 'TEAMS-ADD-FORM.PAGE1.PLC' | translate }}
                  </mat-radio-button>
                  <div class="form-text">
                    {{ 'TEAMS-ADD-FORM.PAGE1.TEAM-PLC-INFO' | translate }}
                  </div>
                </div>
                <div>
                  <mat-radio-button
                    [value]="'Personnel'"
                    [ngClass]="{'bold-text' : selectedType === 'Personnel'}">
                    {{ 'TEAMS-ADD-FORM.PAGE1.PERSONAL' | translate }}
                  </mat-radio-button>
                  <div class="form-text">
                    {{ 'TEAMS-ADD-FORM.PAGE1.TEAM-PERSONNEL-INFO' | translate }}
                  </div>
                </div>
              }
            </mat-radio-group>
          </div>
          <div class="name-container" fxLayout="column" fxLayoutAlign="start start">
            <h3 class="labels">
              {{ 'TEAMS-ADD-FORM.PAGE1.NAME' | translate }}
            </h3>
            <div class="form-text">
              {{ 'TEAMS-ADD-FORM.PAGE1.NAMEINFO' | translate }}
            </div>
            <mat-form-field class="step-input" fxFlex appearance="outline">
              <mat-label
                >{{ 'TEAMS-ADD-FORM.PAGE1.NAMELABEL' | translate
                }}</mat-label
              >
              <input
                autocomplete="on"
                matInput
                formControlName="teamsName"
                required />
              @if (addTeamsForm.get('teamsName').hasError('required')) {
              <mat-error
                >{{ 'TEAMS-ADD-FORM.PAGE1.NAMEREQUIREDERROR' | translate
                }}</mat-error
              >
              } @else if (addTeamsForm.get('teamsName').hasError('pattern')) {
              <mat-error
                >{{ 'TEAMS-ADD-FORM.PAGE1.NAMEPATTERNERROR' | translate
                }}</mat-error
              >
              }
            </mat-form-field>
          </div>
          <div
              fxLayout="column"
              class="mr-16 text-container"
              fxLayoutAlign="start start">
              <h3>
                {{ 'TEAMS-ADD-FORM.PAGE1.PROVISIONALNAMESTITLE' |
                translate }}
              </h3>
              <div>
                {{ 'TEAMS-ADD-FORM.PAGE1.PROVISIONALNAMESINFO' |
                translate }}
              </div>
            </div>
            <div fxLayout="column" class="name-input-container">
              <mat-form-field
                class="step-input name-input"
                fxFlex="50"
                fxFlex
                appearance="outline">
                <mat-label
                  >{{ 'TEAMS-ADD-FORM.PAGE1.DISPLAYNAME' | translate
                }}</mat-label
                ><input matInput [value]="createDisplayName()" disabled/>
              </mat-form-field>
              <mat-form-field
                class="step-input name-input"
                fxFlex="50"
                fxFlex
                appearance="outline">
                <mat-label
                  >{{ 'TEAMS-ADD-FORM.PAGE1.EMAIL' | translate
                  }}</mat-label
                ><input
                  matInput
                  [value]="createMailAddress() ? createMailAddress() + '@edu.vs.ch': ''"
                  disabled
              /></mat-form-field>
            </div>
        </form>
        <div
          class="general-container"
          fxLayout="row"
          fxLayoutAlign="end center">
          <button
            mat-raised-button
            matStepperNext
            type="button"
            color="accent"
            [disabled]="!step1Validation()">
            {{ 'GENERAL.NEXT' | translate }}
          </button>
        </div>
      </mat-step>
      <mat-step>
        <form fxLayout="column" fxFill [formGroup]="addTeamsForm">
          <h2 class="step-title">
            {{ 'TEAMS-ADD-FORM.PAGE2.TITLE' | translate }}
          </h2>
          @if(!isClassTeams){
            <div fxLayout="column" fxLayoutAlign="start start">
              <h3 class="labels">
                {{ 'TEAMS-ADD-FORM.PAGE2.DESCRIPTION' | translate }}
              </h3>
              <mat-form-field class="step-input" fxFlex appearance="outline">
                <mat-label
                  >{{ 'TEAMS-ADD-FORM.PAGE2.DESCRIPTIONLABEL' | translate
                  }}</mat-label
                >
                <textarea
                  class="textarea"
                  matInput
                  formControlName="teamsDescription"></textarea>
              </mat-form-field>
            </div>
          }
          <div fxLayout="column" fxLayoutAlign="start start">
            <h3 class="labels">
              {{ 'TEAMS-ADD-FORM.PAGE2.LIFESPAN' | translate }}
            </h3>
            <mat-radio-group
              class="radio-teams-type"
              formControlName="teamsLifespan">
              @if(isClassTeams) {
                <mat-radio-button [value]="currentSchoolYear"
                >{{ 'TEAMS-ADD-FORM.PAGE2.SCHOOLYEAR' | translate }}
                {{currentSchoolYear}}</mat-radio-button
                >
                @if(canShowNextYear()) {
                <mat-radio-button [value]="nextSchoolYear"
                  >{{ 'TEAMS-ADD-FORM.PAGE2.SCHOOLYEAR' | translate }}
                  {{nextSchoolYear}}</mat-radio-button
                >
                }
              }@else{
                <mat-radio-button [value]="'Equipe permanente'">
                  {{ 'TEAMS-ADD-FORM.PAGE2.PERMANENT' | translate}}
                </mat-radio-button>
              }
            </mat-radio-group>
          </div>
        </form>
        <div
          class="general-container"
          fxLayout="row"
          fxLayoutAlign="space-between center">
          <button
            class="btn-container"
            mat-raised-button
            matStepperPrevious
            type="button"
            color="accent">
            {{ 'GENERAL.PREVIOUS' | translate }}
          </button>
          <button
            mat-raised-button
            matStepperNext
            type="button"
            color="accent"
            [disabled]="!(addTeamsForm.valid)">
            {{ 'GENERAL.NEXT' | translate }}
          </button>
        </div>
      </mat-step>
      <mat-step>
        <div
          fxLayout="column"
          class="mr-16 text-container"
          fxLayoutAlign="start start">
          <h3 class="labels">
            {{ 'TEAMS-ADD-FORM.PAGE3.OWNER' | translate }}
          </h3>
        </div>
        <div fxLayout="row" class="users-container">
          <div fxLayout="column" fxFlex="90" class="users-selected">
            <mat-form-field
              class="chip-list"
              appearance="fill"
              class="nom-access">
              <mat-label
                >{{ 'TEAMS-ADD-FORM.PAGE3.OWNERLABEL' | translate
                }}</mat-label
              >
              <mat-chip-grid
                #gridOwnerSelection
                aria-label="User selection"
                class="mat-chip-list label-chips">
                <mat-chip-row
                  *ngFor="let user of users_owner"
                  (removed)="removeUsersOwner(user)"
                  class="mat-chip mat-standard-chip label-chip background-selected">
                  {{ user.officialemail }}
                  <button matChipRemove class="removeBtn">
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip-row>
              </mat-chip-grid>
              <input [matChipInputFor]="gridOwnerSelection" hidden />
            </mat-form-field>
          </div>
          <div
            class="button-user-selected"
            fxLayout="column"
            fxDirection="end"
            fxFlex="10"
            fxLayoutAlign="center center">
            <button
              mat-raised-button
              type="button"
              color="accent"
              class="add-nom-btn"
              (click)="addUsersOwner()">
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </div>
        <div
          fxLayout="column"
          class="mr-16 text-container"
          fxLayoutAlign="start start">
          <div class="form-text">
            {{ 'TEAMS-ADD-FORM.PAGE3.OWNERSINFOTEXT' | translate }}
          </div>
        </div>
        <div
          class="general-container"
          fxLayout="row"
          fxFill="100"
          *ngIf="isErrorCreateTeams">
          <div
            class="message-box error user-created"
            *ngIf="errorCreateTeams.error.code === 'ERR2'">
            {{ 'ERROR.2' | translate }}
          </div>
          <div
            class="message-box error user-created"
            *ngIf="errorCreateTeams.error.code === 'ERR18'">
            {{ 'ERROR.18' | translate }}
          </div>
          <div
            class="message-box error user-created"
            *ngIf="errorCreateTeams.error.code === 'ERR21'">
            {{ 'ERROR.21' | translate }}
          </div>
          <div
            class="message-box error user-created"
            *ngIf="errorCreateTeams.error.code === 'ERR30'">
            {{ 'ERROR.30' | translate }}
          </div>
          <div
            class="message-box error user-created"
            *ngIf="errorCreateTeams.error.code === 'ERR31'">
            {{ 'ERROR.31' | translate }}
          </div>
          <div
            class="message-box error user-created"
            *ngIf="errorCreateTeams.error.code === 'ERR32'">
            {{ 'ERROR.32' | translate }}
          </div>
          <div
            class="message-box error user-created"
            *ngIf="errorCreateTeams.error.code === 'ERR40'">
            {{ 'ERROR.40' | translate }}
          </div>
          <div
            class="message-box error user-created"
            *ngIf="errorCreateTeams.error.code === 'ERR403'">
            {{ 'ERROR.402' | translate }}
          </div>
          <div
            class="message-box error user-created"
            *ngIf="errorCreateTeams.error.code === undefined">
            {{ 'ERROR.2' | translate }}
          </div>
          <div
            class="message-box error user-created"
            *ngIf="errorCreateTeams.error.code === null">
            {{ 'ERROR.2' | translate }}
          </div>
        </div>
        <div
          class="general-container"
          fxLayout="column"
          fxLayoutAlign="center center"
          *ngIf="isBusyCreateTeams">
          <div fxFlex="100">
            <mat-progress-spinner
              [color]="spinner.color"
              [mode]="spinner.mode"
              [value]="spinner.value"
              [diameter]="spinner.diameter">
            </mat-progress-spinner>
          </div>
          <br />
          <div fxFlex="100">{{ 'TEAMS-ADD-FORM.LOADING' | translate }}</div>
        </div>
        <div
          class="success-container"
          fxLayout="column"
          fxFill="100"
          *ngIf="isTeamsCreated">
          <div class="row">
            <div class="message-box success user-created">
              {{ 'TEAMS-ADD-FORM.SUCCESS' | translate }}
            </div>
          </div>
          <div class="row">
            <button
              mat-raised-button
              matStepperNext
              type="button"
              color="accent"
              class="btn-submit"
              (click)="matDialogRef.close()">
              {{ 'GENERAL.LEAVE' | translate }}
            </button>
          </div>
        </div>
        <div
          class="general-container"
          fxLayout="row"
          fxLayoutAlign="space-between center"
          *ngIf="!isTeamsCreated">
          <button
            class="btn-container"
            mat-raised-button
            matStepperPrevious
            type="button"
            color="accent">
            {{ 'GENERAL.PREVIOUS' | translate }}
          </button>
          <button
            mat-raised-button
            type="button"
            color="accent"
            (click)="createTeams()"
            [disabled]="addTeamsForm.invalid || users_owner === null || users_owner.length === 0">
            {{ 'GENERAL.SAVE' | translate }}
          </button>
        </div>
      </mat-step>
    </mat-horizontal-stepper>
  </div>
</div>
